import { PdfReportPage, PdfReportPageProps } from "./PdfReportPage";
import { CarPdfHeading } from "@app/components/PdfHeading";
import { CarPdfMarkdown } from "@app/components/PdfMarkdown";
import {
  CarDisclosureContentCode,
  UseDisclosures,
} from "@app/hooks/useDisclosures";

export interface ImportantInformationPdfPageProps {
  pageProps: PdfReportPageProps;
  disclosures: UseDisclosures;
}

export const ImportantInformationPdfPage = (
  props: ImportantInformationPdfPageProps,
) => (
  <PdfReportPage {...props.pageProps}>
    <CarPdfHeading label="Important Information" style={{ marginBottom: 14 }} />
    <CarPdfMarkdown>
      {props.disclosures.getContent(
        CarDisclosureContentCode.CMPAS_CLIENT_REPORT_IMPORTANT_INFORMATION_part_10,
      )}
    </CarPdfMarkdown>
  </PdfReportPage>
);
